import { inject, Inject, Injectable } from '@angular/core'
import { createEffect, ofType } from '@ngrx/effects'
import { SharedAuctionFacade } from 'libs/shared/models/auction/auction.models'
import { catchError, concatMap, map, mergeMap, tap } from 'rxjs'
import { ImagesApiService } from './images-api.service'
import * as ImagesActions from './images.actions'
import * as SharedImagesActions from 'libs/shared/images/data-access/src/lib/+state/shared-images.actions'
import { ProjectorTemplateImageResponse } from './images.models'
import { SharedImagesEffects } from 'libs/shared/images/data-access/src/lib/+state/shared-images.effects'

@Injectable()
export class ImagesEffects extends SharedImagesEffects {
  private readonly imagesApiService = inject(ImagesApiService)

  openTemplateImageUploadDialog$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ImagesActions.openTemplateImageUploadDialog),
      map((action) =>
        ImagesActions.openImageUploadDialog({
          config: {
            onUpload: (image) =>
              action.templateUuid
                ? ImagesActions.uploadTemplateImage({ image, templateUuid: action.templateUuid })
                : SharedImagesActions.uploadImage({ image }),
          },
          onSuccess: (images) => action.onSuccess?.(images),
        }),
      ),
    ),
  )

  uploadTemplateImage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ImagesActions.uploadTemplateImage),
      tap(() => this.gbImageUploadService.setWaitingOnResponse(true)),
      concatMap((action) =>
        this.imagesApiService.uploadTemplateImage(action.templateUuid, action.image).pipe(
          mergeMap((response: ProjectorTemplateImageResponse) => this.handleUploadSuccess(response)),
          catchError((error) => this.handleUploadFailure(error)),
        ),
      ),
    ),
  )

  constructor(@Inject('AuctionFacade') public auctionFacade: SharedAuctionFacade) {
    super(auctionFacade)
  }
}
